<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >



      <div
        class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto"
      >

      <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :is-full-page="fullPage"></loading>
    </div>    

        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="flex flex-col items-center">
          <form
            class="form-group w-full max-w-lg"
            id="updateRegisterModalForm"
            @submit.prevent
          >


            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold">Editar registro</div>
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="title"
                >Título *</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="title"
                  name="title"
                  type="text"
                  v-model="title"
                />
                <p
                  v-if="errors.title"
                  class="text-red-500 text-xs italic text-left"
                >Escriba un título</p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="description"
                >Descripción *</label>
                <textarea
                  class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  id="description"
                  type="text"
                  name="description"
                  v-model="description"
                />
                <p
                  v-if="errors.description"
                  class="text-red-500 text-xs italic text-left"
                >Escriba una descripción.</p>
              </div>
            </div>            

            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >Proyecto *</label
                >
                <div class="relative">
                  <select
                    id="project"
                    name="project"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                    v-model="selectedProject"
                  >
                    <option value="" disabled>
                      Seleccione un proyecto
                    </option>
                    <template v-for="project in arrayProjects">
                      <option :key="project.id" :value="project">
                        {{ project.nombre }}
                      </option>
                    </template>
                    <!-- <option v-for="(proyecto, id) in arrayProjects" :key="id">
                      {{ proyecto.nombre }}
                    </option> -->
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
                <!-- <p>{{selectedProject}}</p> -->
                <p
                  v-if="errors.project"
                  class="text-red-500 text-xs italic text-left"
                >
                  Seleccione una proyecto
                </p>
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >Categoría*</label
                >
                <div class="relative">
                  <select
                    id="category"
                    name="category"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                    v-model="selectedCategory"
                  >
                    <option value="" disabled>Seleccione una categoría</option>
                    <template v-for="category in arrayMainCategories">
                      <option
                        :value="category"
                        :key="category.id"
                      >
                        {{ category.nombre }}
                      </option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>

                <p
                  v-if="errors.category"
                  class="text-red-500 text-xs italic text-left"
                >
                  Seleccione una categoría
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >Tipo*</label
                >
                <div class="relative">
                  <select
                    id="type"
                    name="type"
                    v-model="selectedType"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  >
                    <option value="" disabled>
                      Selecciona un tipo
                    </option>
                    <template>
                      <option
                        v-for="type in arrayTypes"
                        :key="type.id"
                        :value="type"
                      >
                        {{ type.nombre }}
                      </option>
                    </template>

                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>

                <p
                  v-if="errors.type"
                  class="text-red-500 text-xs italic text-left"
                >
                  Seleccione un tipo
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >Subcategoría*</label
                >
                <div class="relative">
                  <select
                    id="subCategory"
                    name="subCategory"
                    v-model="selectedSubCategory"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  >
                    <option value="" disabled>Seleccione una subcategoría</option>
                    <template v-for="subCategory in arraySubCategories">
                      <option
                        :key="subCategory.id"
                        :value="subCategory"
                      >
                        {{ subCategory.nombre }}
                      </option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>

                <p
                  v-if="errors.subCategory"
                  class="text-red-500 text-xs italic text-left"
                >
                  Seleccione una subcategoría
                </p>
              </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >Visibilidad*</label
                >
                <div class="relative">
                  <select
                    id="visibility"
                    name="visibility"
                    v-model="selectedVisibility"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
                  >
                    
                    <option value="" disabled>Seleccione un tipo de visibilidad</option>
                    <template v-for="visibility in this.arrayVisibility">
                      <option
                        :key="visibility.value"
                        :value="visibility"
                      >
                        {{ visibility.text }}
                      </option>
                    </template>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>

                <p
                  v-if="errors.visibility"
                  class="text-red-500 text-xs italic text-left"
                >
                  Seleccione un tipo de visibilidad
                </p>
              </div>
            </div>

            <div class="flex w-full justify-end">
              <button
                class="bg-cdmx-blue-light hover:bg-cdmx-blue-dark px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                @click="save()"
              >
                Guardar
              </button>
              <button
                class="ml-2 bg-red-500 hover:bg-cdmx-red px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                @click="close()"
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

//import polygon from "../assets/polygonChapp.json";

//import { LMap, LGeoJson } from "vue2-leaflet";

//import * as esri from "esri-leaflet";

export default {
  name: "place-modal",
  data() {
    return {
      arrayProjects: [],
      arrayMainCategories: [],
      arrayTypes: [],
      arraySubCategories: [],
      arrayVisibility: [
        { value: false, text: 'Público' },
        { value: true, text: 'Privado' }
      ],
      selectedCategory: "",
      selectedType: "",
      selectedSubCategory: "",
      selectedProject: "",
      selectedVisibility: "",
      title : "",
      description : "",     
      
      isLoading: false,
      fullPage: true,
      featuresList: [],      

      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      errors: {
        title: false,
        description: false,
        project: false,
        category: false,
        type: false,
        subCategory: false,
        visibility: false,
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    place: {
      required: true
    },
    aux_place: {
      required: true
    },    
    modalAction: {
      required: true
    },   
    geometries: {
      required: true
    }
  },
  components: {
     Loading
  },  
  watch: {
    showing(value) {
      if (value) {
        // console.log(this.place)


        this.fetchProjects();
        this.fetchMainCategories();
        this.fetchTypes();
        this.fetchSubCategories();
        this.getVisibility();


        this.title = this.place.nombre;
        this.description = this.place.descripcion;
        //this.selectedProject = parseInt(this.place.id_proyecto);
/*         console.log(this.arrayProjects)
        this.arrayProjects.forEach(project =>{
          console.log(project)
        }) */


        this.selectedProject = this.place.id_proyecto;
        // console.log(this.selectedProject)

        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
    // selectedCategory: function () {
    //   this.optThreads = [];
    //   this.subCategories = [];
    //   this.selectedOptThread = "";
    //   this.selectedSubCategory = "";

    //   if (this.selectedCategory.length > 0) {
    //     this.optThreads = this.arrayMainCategories[this.selectedCategory];
    //   }
    // },
    selectedType:function(){
      //console.log("selectedType")
      ///console.log(this.selectedType)
      this.fetchSubCategories();
      if(this.selectedCategory != ""){
        this.fetchSubCategories(this.selectedCategory.id,this.selectedType.id);
      }
    },
    selectedCategory:function(){
      //console.log("selectedCategory")
      //console.log(this.selectedCategory)
      //console.log(this.selectedType)
      if(this.selectedType != ""){
         //console.log("tipo seleccionado")
         this.fetchSubCategories(this.selectedCategory.id,this.selectedType.id);
      }
    }

  },
  methods: {
    reset() {
      this.title = "";
      this.description = "";
      this.optThreads = [];
      this.subCategories = [];
      this.selectedCategory = "";
      this.selectedType = "";
      this.selectedSubCategory = "";
      this.selectedProject = "";
      this.selectedVisibility = "";
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    savedSuccesfully(){
      this.$emit("saved");
    },    
    save() {
      console.log("guardar!!");

      const form = document.getElementById("updateRegisterModalForm");
      const formData = new FormData(form);
      const validForm = this.checkFormNewNotice(formData);
      let GeoJSONPlaces = "";

      let projectInfo = {
        id: this.selectedProject.id,
        nombre: this.selectedProject.nombre
      }
      let categoryInfo = {
        id: this.selectedCategory.id,
        nombre: this.selectedCategory.nombre
      }
      let subCategoryInfo = {
        id: this.selectedSubCategory.id,
        id_maincategory: this.selectedSubCategory.id_maincategory,
        nombre: this.selectedSubCategory.nombre,
        tipo_id: this.selectedSubCategory.tipo_id
      }
      let typeInfo = {
        id: this.selectedType.id,
        nombre: this.selectedType.nombre
      }

      // console.log(this.place.geojson);
      // console.log(typeof this.place.geojson);
      

      if (typeof this.place.geojson == 'string') {
        GeoJSONPlaces = JSON.parse(this.place.geojson);
      } else {  // si es tipo object, ya no hace el parse
        GeoJSONPlaces = this.place.geojson;
      }
      
      // console.log(GeoJSONPlaces);
      
      for(let i = 0; i < GeoJSONPlaces.features.length; i ++){

        if(GeoJSONPlaces.features[i].properties.projectInfo) {
          GeoJSONPlaces.features[i].properties.projectInfo = projectInfo
        }
        if(GeoJSONPlaces.features[i].properties.categoryInfo) {
          GeoJSONPlaces.features[i].properties.categoryInfo = categoryInfo
        }
        if(GeoJSONPlaces.features[i].properties.typeInfo) {
          GeoJSONPlaces.features[i].properties.typeInfo = typeInfo
        }
        if(GeoJSONPlaces.features[i].properties.subCategoryInfo){
          GeoJSONPlaces.features[i].properties.subCategoryInfo = subCategoryInfo
        }
        if(GeoJSONPlaces.features[i].properties.nombre) {
          GeoJSONPlaces.features[i].properties.nombre = this.title
        }
        if(GeoJSONPlaces.features[i].properties.descripcion) {
          GeoJSONPlaces.features[i].properties.descripcion = this.description
        }
      }

      // console.log(this.place.geojson);
      // console.log(GeoJSONPlaces);

      if(validForm) {
        let dataGeom = {
          geometries: GeoJSONPlaces
        }

        let data = {
          id_proyecto: this.selectedProject.id,
          id_cat_principal: this.selectedCategory.id,
          id_cat_secundaria: this.selectedSubCategory.id,
          id_tipo: this.selectedType.id,
          nombre: this.title,
          descripcion: this.description,
          privado: this.selectedVisibility.value,
          //fecha: new Date(),
          //usuario: localStorage.getItem("email"),
          //privado: false,
          //geometries: GeoJSONPlaces
          //geometries: this.geometries
        }

        this.axios
          .put(
            backend_url + "/api/ppd/levantamiento/updateLevantamientoGeometries/"+this.place.id,
            dataGeom,
            this.config
          )
          .then((response) => {
            // console.log(response);
            // console.log(response.data.status);
            if(response.data.status == 'ok'){
              // console.log("Se ha actualizado el geojson")
              this.isLoading=false;
              this.savedSuccesfully();              
            }
          })
          .catch((error) => {
            console.log(error);
            this.showingError = true;
            this.isLoading=false;
            alert("Ha ocurrido un error");
          }        
        );

        this.axios
          .put(
            backend_url + "/api/ppd/levantamiento/updateLevantamiento/"+this.place.id,
            data,
            this.config
          )
          .then((response) => {
            // console.log(response);
            // console.log(response.data.status);
            if(response.data.status == 'ok'){
              // console.log("Se han guardado los datos")
              this.isLoading=false;
              this.savedSuccesfully();              
            }
          })
          .catch((error) => {
            console.log(error);
            this.showingError = true;
            this.isLoading=false;
            alert("Ha ocurrido un error");
          }        
          );

        this.close(true);   

      } else {
        console.log("Formulario no válido");
      }

    },

    checkFormNewNotice: function (dataForm) {
      if (dataForm.get("title").trim() === "") {
        this.errors.title = true;

      } else {
        this.errors.title = false;
      }

      // console.log(dataForm.get("description"));
      if (dataForm.get("description").trim() === "") {
        this.errors.description = true;
      } else {
        this.errors.description = false;
      }

      // console.log(dataForm.get("project"));
      if (dataForm.get("project") === "" || dataForm.get("project") === null) {
        this.errors.project = true;
      } else {
        this.errors.project = false;
      }

      if (dataForm.get("category") === "" || dataForm.get("category") === null) {
        this.errors.category = true;
      } else {
        this.errors.category = false;
      }

      if (dataForm.get("type") === "" || dataForm.get("type") === null) {
        this.errors.type = true;
      } else {
        this.errors.type = false;
      }

      if (dataForm.get("subCategory") === "" || dataForm.get("subCategory") === null) {
        this.errors.subCategory = true;
      } else {
        this.errors.subCategory = false;
      }

      if (dataForm.get("visibility") === "" || dataForm.get("visibility") === null) {
        this.errors.visibility = true;
      } else {
        this.errors.visibility = false;
      }

      if (
        this.errors.title ||
        this.errors.description ||
        this.errors.project ||
        this.errors.category ||
        this.errors.type ||
        this.errors.subCategory ||
        this.errors.visibility
      ) {
        return false;
      }

      return true;
    },
    convertGeoJSON_WKT(polygon) {
      var wkt_str =
        "POLYGON(" +
        polygon.coordinates
          .map(function (ring) {
            return (
              "(" +
              ring
                .map(function (p) {
                  return p[0] + " " + p[1];
                })
                .join(", ") +
              ")"
            );
          })
          .join(", ") +
        ")";
      return wkt_str;
    },
    fetchProjects() {
      this.axios
        .get(backend_url + "/api/ppd/proyectos/getProjects", this.config)
        .then((response) => {
          //console.log(response.data.proyectos);
          this.arrayProjects = response.data.proyectos;
          //console.log(this.arrayProjects)
          this.arrayProjects.forEach(project =>{
            //console.log(project)
            if(project.id == this.place.id_proyecto){
              this.selectedProject = project
            }
          })          

        });
    },
    fetchMainCategories() {
      this.axios
        .get(backend_url + "/api/ppd/catprinc/getMainCategories", this.config)
        .then((response) => {
          //console.log(response.data.categorias);
          this.arrayMainCategories = response.data.categorias;

          this.arrayMainCategories.forEach(category =>{
            //console.log(project)
            if(category.id == this.place.id_cat_principal){
              this.selectedCategory = category
            }
          })  

        });
    },
    fetchTypes() {
      this.axios
        .get(backend_url + "/api/ppd/tipolevantamiento/getTypes", this.config)
        .then((response) => {
          //console.log(response.data.tipos);
          this.arrayTypes = response.data.tipos;

          this.arrayTypes.forEach(type =>{
            //console.log(project)
            if(type.id == this.place.id_tipo){
              this.selectedType = type
            }
          })            
        });
    },
    fetchSubCategories(id_category, id_type) {
      this.selectedSubCategory = ""
      let data = {
/*         id_maincategory: id_category,
        id_type: id_type */
      }
      this.axios
        .get(
          backend_url + "/api/ppd/subcategorias/getAllSubcategories",
           this.config
        )
        .then((response) => {
          //console.log(response.data.subcategorias);
          this.arraySubCategories = response.data.subcategorias;

          this.arraySubCategories.forEach(subcategory =>{
            //console.log(project)
            if(subcategory.id == this.place.id_cat_secundaria){
              this.selectedSubCategory = subcategory
            }
          })           
        });
    },
    getVisibility() {
      this.arrayVisibility = [{ value: false, text: 'Público' }, { value: true, text: 'Privado' }],
      this.arrayVisibility.forEach(visibility => {
        if( visibility.value == this.place.privado ) {
          this.selectedVisibility = visibility
        }
      })
    },
  },
  mounted() {
    //console.log(this.place)
  },
  created() {
    //console.log(this.place)
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.text-teal-700 {
  color: #6e5b25;
}
</style>
